import type { InputHTMLAttributes } from 'react';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
}

export function Checkbox({ label, className = '', id, ...rest }: CheckboxProps) {
  const inputId = id ?? rest.name;
  return (
    <label
      htmlFor={inputId}
      className="inline-flex items-center gap-2 cursor-pointer select-none text-sm text-gray-800"
    >
      <input
        id={inputId}
        type="checkbox"
        {...rest}
        className={`
          h-4 w-4 rounded border-gray-300 text-booku-primary
          focus:ring-2 focus:ring-booku-primary focus:ring-offset-0
          disabled:opacity-60 disabled:cursor-not-allowed
          ${className}
        `}
      />
      <span>{label}</span>
    </label>
  );
}
